import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminLayout from "@/components/layouts/AdminLayout";
import ResellerLayout from "@/components/layouts/ResellerLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminResellers from "@/pages/admin/Resellers";
import AdminResellerDetail from "@/pages/admin/ResellerDetail";
import AdminRecharges from "@/pages/admin/AllRecharges";
import AdminSettings from "@/pages/admin/SessionSettings";
import AdminAlerts from "@/pages/admin/Alerts";
import AdminNoblePacks from "@/pages/admin/NoblePacks";
import AdminApiDocs from "@/pages/admin/ApiDocs";
import AdminAccount from "@/pages/admin/AdminAccount";
import ResellerDashboard from "@/pages/reseller/ResellerDashboard";
import RechargePage from "@/pages/reseller/Recharge";
import HistoryPage from "@/pages/reseller/History";

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/reseller"} replace />;
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/reseller"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route
            path="/admin"
            element={
              <Protected role="admin">
                <AdminLayout />
              </Protected>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="resellers" element={<AdminResellers />} />
            <Route path="resellers/:id" element={<AdminResellerDetail />} />
            <Route path="recharges" element={<AdminRecharges />} />
            <Route path="noble-packs" element={<AdminNoblePacks />} />
            <Route path="api-docs" element={<AdminApiDocs />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="account" element={<AdminAccount />} />
            <Route path="alerts" element={<AdminAlerts />} />
          </Route>

          <Route
            path="/reseller"
            element={
              <Protected role="reseller">
                <ResellerLayout />
              </Protected>
            }
          >
            <Route index element={<ResellerDashboard />} />
            <Route path="recharge" element={<RechargePage />} />
            <Route path="history" element={<HistoryPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
